import { UserRoleEnum } from '@/types/auth.types';

const REMEMBER_ME_INFO_KEY = 'rememberMeInfo' as const;

const USER_ROLES_NAME = {
  [UserRoleEnum.organization]: 'チェーン',
  [UserRoleEnum.sbf_master]: '事務局',
  [UserRoleEnum.sbs_sales]: '特販部',
  [UserRoleEnum.sbs_tag_team]: 'TAG TEAM',
  [UserRoleEnum.sbs_operation]: '事務局',
  [UserRoleEnum.wedding]: '企画',
} as const;

export { REMEMBER_ME_INFO_KEY, USER_ROLES_NAME };
